"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardPluginV1 = void 0;
/**
 * Abstract base class for the Dashboard Plugin.
 *
 * @remarks
 * Each plugin should extend this class and implement at least the {@link DashboardPluginV1.register} method.
 *
 * @public
 */
var DashboardPluginV1 = /** @class */ (function () {
    function DashboardPluginV1() {
        this._pluginVersion = "1.0";
        this.minEngineVersion = "bundled";
        this.maxEngineVersion = "bundled";
    }
    return DashboardPluginV1;
}());
exports.DashboardPluginV1 = DashboardPluginV1;
//# sourceMappingURL=plugin.js.map